import axios from 'axios'

const BASE_URL_CALENDAR = '/calendar'

export const getGoogleConnectionUrlService = async () =>
  axios.get(`${BASE_URL_CALENDAR}/google/connect`).then(({ data }) => data)

export const getGoogleConnectionStatusService = async () =>
  axios.get(`${BASE_URL_CALENDAR}/google/status`).then(({ data }) => data)

export const getGoogleCalendarsService = async () =>
  axios.get(`${BASE_URL_CALENDAR}/google/calendars`).then(({ data }) => data)

export const selectGoogleCalendarsService = async ({ calendarIds }) =>
  axios.put(`${BASE_URL_CALENDAR}/google/calendars`, { calendar_ids: calendarIds }).then(({ data }) => data)

export const disconnectGoogleService = async () =>
  axios.delete(`${BASE_URL_CALENDAR}/google/disconnect`).then(({ data }) => data)

export const getGoogleEventsService = async (queryParams) =>
  axios.get(`${BASE_URL_CALENDAR}/google/events?${queryParams}`).then(({ data }) => data)

export const includeGoogleEventService = async ({ eventId, hours, notes }) =>
  axios.post(`${BASE_URL_CALENDAR}/google/events/${eventId}/include`, { hours, notes }).then(({ data }) => data)

export const excludeGoogleEventService = async ({ eventId }) =>
  axios.delete(`${BASE_URL_CALENDAR}/google/events/${eventId}/include`).then(({ data }) => data)
